import { useNavigator } from '@repo/toolkit/use-navigator'
import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'

import { createOlTeflPrice } from '../../../api/ols/tefl-prices/create-ol-tefl-price'
import OlTeflPriceForm from '../../../components/pages/ols/ol-tefl-prices/ol-tefl-price-form'
import { Paths } from '../../../lib/constants/path'
import { twoButtonsConfig } from '../../../lib/utils/buttons-config/validation-buttons-config'
import { showAxiosError } from '../../../lib/utils/functions/misc.functions'
import { constructOlPath } from './utils'

type Props = {
  olId: number
}

const OlTeflPriceCreate: React.FC<Props> = ({ olId }) => {
  const { back } = useNavigator()

  const { mutateAsync } = useMutation({
    mutationFn: createOlTeflPrice,
    onError: showAxiosError,
    onSuccess: () => {
      toast.success('Prix de Tefl créé avec succès')
      back(constructOlPath(Paths.OL_DETAILS_TEFL_PRICES_PAGE, olId))
    }
  })

  return (
    <OlTeflPriceForm
      mode="create"
      buttonsConfig={twoButtonsConfig({
        onConfirm: async (values) => {
          await mutateAsync({ id: olId, ...values })
        },
        onCancel: () => back(constructOlPath(Paths.OL_DETAILS_TEFL_PRICES_PAGE, olId))
      })}
    />
  )
}

export default OlTeflPriceCreate
